import ServiceByRegUlez from "./ulez/ServiceByRegUlez";
import ServiceLadUlez from "./ulez/ServiceLadUlez";

// Two brands, two completely separate pages. ServiceByReg answers "is the car
// I am about to buy ULEZ free", ServiceLad answers "is my own car compliant",
// so they share the lookup and nothing else: different markup, different copy,
// different stylesheet. ServiceBoss sells manufacturer service history and has
// no ULEZ page, so it never reaches here (see the route guard in App.jsx).
const pageByBrand = {
  servicebyreg: ServiceByRegUlez,
  servicelad: ServiceLadUlez,
};

export function hasUlezChecker(brandKey) {
  return Boolean(pageByBrand[brandKey]);
}

export default function UlezCheckerPage({ brand }) {
  const Page = pageByBrand[brand.key];
  if (!Page) return null;
  return <Page brand={brand} />;
}
